module.exports = __webpack_public_path__ + "img/item_bg.54fcecc9.png";